import React from 'react'

export const HorizontalConnection = ({ idCenario = 0, isTransparente = false, margemAcima, distance }) => {
    return (
        <>
            {idCenario===0 && 
                <div 
                    id={222}
                    className={isTransparente ? 'horizontal-connection-transparente' : 'horizontal-connection'}
                    align="center"
                    style={{marginTop: `${margemAcima}px`}}
                    height='500px'
                >{distance} </div>
            }
            {idCenario===1 && 
                <div 
                    id={222}
                    className={isTransparente ? 'horizontal-connection-transparente' : 'horizontal-connection-cenario1'}
                    align="center"
                    style={{marginTop: `${margemAcima}px`}}
                    height='500px'
                >{distance} </div>
            }
            {idCenario===2 && 
                <div 
                    id={222}
                    className={isTransparente ? 'horizontal-connection-transparente' : 'horizontal-connection-cenario2'}
                    align="center"
                    style={{marginTop: `${margemAcima}px`}}
                    height='500px'
                >{distance} </div>
            }
        </>         
    )
}

export default HorizontalConnection
